var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.9,139.6c12.8,0,23.3-10.5,23.3-23.3V69.8h243.3v372.5H216.2v-46.6c0-12.8-10.5-23.3-23.3-23.3 c-12.8,0-23.3,10.5-23.3,23.3v46.6c0,25.6,21,46.6,46.6,46.6h243.3c25.6,0,46.6-21,46.6-46.6V69.8c0-25.6-21-46.6-46.6-46.6H216.2 c-25.6,0-46.6,21-46.6,46.6v46.6C169.6,129.1,180.1,139.6,192.9,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,272.3l96,94.9c4.7,4.1,11.1,5.8,16.9,5.2c6.4-0.6,11.6-3.5,15.7-8.1c7.6-8.7,7-21.5-1.2-31.4l-54.7-54.1h232.2 c12.8,0,23.3-10.5,23.3-23.3c0-12.8-10.5-23.3-23.3-23.3H85.8l53.5-52.4c4.7-4.1,7.6-9.9,8.1-15.7c0.6-6.4-1.2-12.2-5.2-16.9 c-4.1-4.7-9.9-7.6-15.7-8.1c-0.6,0-1.2,0-1.7,0c-5.2,0-11.1,1.7-15.1,5.2c-1.2,0.6-1.7,1.7-1.7,1.7l-94.9,93.7 c-4.7,4.7-7,10.5-7,16.3C5.5,262.4,7.8,268.2,12.5,272.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogOut);
export default __webpack_public_path__ + "static/media/icon-log-out.5faea7cb254ad9d266771bf3e5fd285c.svg";
export { ForwardRef as ReactComponent };